import apiClient from './client';

export const ordersAPI = {
  getAll: () => apiClient.get('/orders/'),
  getById: (id) => apiClient.get(`/orders/${id}/`),
  create: (data) => apiClient.post('/orders/', data),
  update: (id, data) => apiClient.put(`/orders/${id}/`, data),
  updateStatus: (id, status) => apiClient.post(`/orders/${id}/update_status/`, { status }),
  delete: (id) => apiClient.delete(`/orders/${id}/`),
};